import { constOne } from "app/common/utilities/contstants"
import * as t from "io-ts"
import * as td from "io-ts-types"

export const PagingParametersC = t.type({
  page: td.withFallback(t.union([td.NumberFromString, t.number]), constOne()),
  pageSize: td.withFallback(t.union([td.NumberFromString, t.number]), 10),
})
